import React, { useState } from "react";
import { pdfjs, Document, Page } from 'react-pdf';

//react-pdf styles
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Pagination, Row, PaginationItem, PaginationLink } from "reactstrap";

//react-pdf worker config
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ReportViewerRenderer = ({ file }) => {

    const width = window.visualViewport.width > 1080 ? 1080 : window.visualViewport.width;

    const [numPages, setNumPages] = useState();
    const [pageHeight, setPageHeight] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = async (pdf) => {
        //Get height of the page
        const heightOfPage = await pdf
        .getPage(1)
        .then((page) => page.getViewport({ scale: 1.4 }).height);

        setNumPages(pdf.numPages);
        setPageHeight(heightOfPage);
    }

    return (
        <>
            {file && 
                <>

                    <Row className="text-center justify-content-center mt-3">
                        <nav aria-label="Page navigation example">
                            <Pagination
                                className="pagination justify-content-end"
                                listclassname="justify-content-end"
                            >
                                <PaginationItem disabled={pageNumber === 1}>
                                    <PaginationLink
                                        href="#previous-page"
                                        onClick={e => {
                                            e.preventDefault()
                                            setPageNumber(pageNumber - 1);
                                        }}
                                        tabIndex="-1"
                                        className="bg-info text-white"
                                    >
                                        <i className='fa fa-angle-double-left'></i>
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber < 3}>
                                    <PaginationLink href="#minus-two" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber - 2);
                                    }}>
                                        {pageNumber > 2 ? pageNumber - 2 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber <= 1}>
                                    <PaginationLink href="#minus-one"
                                        onClick={e => {
                                            e.preventDefault();
                                            setPageNumber(pageNumber - 1);
                                        }}>
                                        {pageNumber >= 2 ? pageNumber - 1 : " " }
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem active>
                                    <PaginationLink href="#actual-page" onClick={e => { e.preventDefault() }} className="bg-info">
                                        {pageNumber}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber === numPages}>
                                    <PaginationLink href="#plus-one" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 1);
                                    }}>
                                        {pageNumber < numPages ? pageNumber + 1 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={!((numPages - pageNumber) >= 2)}>
                                    <PaginationLink href="#plus-two" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 2);
                                    }}>
                                        {(numPages - pageNumber) >= 2 ? pageNumber + 2 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={!(pageNumber < numPages)}>
                                    <PaginationLink href="#next-page" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 1);
                                    }}
                                        className="bg-info text-white"
                                    >
                                        <i className='fa fa-angle-double-right'></i>
                                    </PaginationLink>
                                </PaginationItem>

                            </Pagination>
                        </nav>
                    </Row>

                    <Row className="text-center justify-content-center mt-3">
                        <div style={{minHeight: `${pageHeight}px`}}>
                            <Document file={{data: file}} onLoadSuccess={onDocumentLoadSuccess} >
                                <Page 
                                    width={width/1.4}
                                    pageNumber={pageNumber}
                                ></Page>
                            </Document>
                        </div>
                    </Row>

                    <Row className="text-center justify-content-center mt-3">
                        <nav aria-label="Page navigation example">
                            <Pagination
                                className="pagination justify-content-end"
                                listclassname="justify-content-end"
                            >
                                <PaginationItem disabled={pageNumber === 1}>
                                    <PaginationLink
                                        href="#previous-page"
                                        onClick={e => {
                                            e.preventDefault()
                                            setPageNumber(pageNumber - 1);
                                        }}
                                        tabIndex="-1"
                                        className="bg-info text-white"
                                    >
                                        <i className='fa fa-angle-double-left'></i>
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber < 3}>
                                    <PaginationLink href="#minus-two" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber - 2);
                                    }}>
                                        {pageNumber > 2 ? pageNumber - 2 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber <= 1}>
                                    <PaginationLink href="#minus-one"
                                        onClick={e => {
                                            e.preventDefault();
                                            setPageNumber(pageNumber - 1);
                                        }}>
                                        {pageNumber >= 2 ? pageNumber - 1 : " " }
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem active>
                                    <PaginationLink href="#actual-page" onClick={e => { e.preventDefault() }} className="bg-info">
                                        {pageNumber}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={pageNumber === numPages}>
                                    <PaginationLink href="#plus-one" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 1);
                                    }}>
                                        {pageNumber < numPages ? pageNumber + 1 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={!((numPages - pageNumber) >= 2)}>
                                    <PaginationLink href="#plus-two" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 2);
                                    }}>
                                        {(numPages - pageNumber) >= 2 ? pageNumber + 2 : " "}
                                    </PaginationLink>
                                </PaginationItem>

                                <PaginationItem disabled={!(pageNumber < numPages)}>
                                    <PaginationLink href="#next-page" onClick={e => {
                                        e.preventDefault();
                                        setPageNumber(pageNumber + 1);
                                    }}
                                        className="bg-info text-white"
                                    >
                                        <i className='fa fa-angle-double-right'></i>
                                    </PaginationLink>
                                </PaginationItem>

                            </Pagination>
                        </nav>
                    </Row>
                    
                </>
            }
        </>
    )
}

export default React.memo(ReportViewerRenderer);